import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import { withStyles, Card, CardHeader, CardContent, Grid, CardActions, Button } from '@material-ui/core'
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState, convertFromHTML, ContentState } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import FileUpload from '../AddNew/FileUpload';
import { PostData } from '../../api/service';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

const styles = theme => ({

})

const semesters = [
    {
        label: '1st Sem - Group B',
        value: '1B'
    },
    {
        label: '2nd Sem - Group B',
        value: '2B'
    },
    {
        label: '3rd Sem',
        value: '3'
    },
    {
        label: '4th Sem',
        value: '4'
    },
    {
        label: '5th Sem',
        value: '5'
    },
    {
        label: '6th Sem',
        value: '6'
    },
    {
        label: '7th Sem',
        value: '7'
    },
    {
        label: '8th Sem',
        value: '8'
    }
]

class LaboratoryLanding extends Component {
    state = {
        description: EditorState.createEmpty(),
        lab_experiments: EditorState.createEmpty(),
        lab_manual: [],
        lab_name: '',
        semester: ''
    }
    onChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    onEditorStateChange = (name,editorState) => {
        
        this.setState({
            [name]: editorState
        });
    };

    onSubmit = (e) => {
        e.preventDefault();

        let {lab_name, semester, lab_manual, lab_experiments, description} = this.state;

        let d = {
            description: stateToHTML(description.getCurrentContent()),
            lab_experiments: stateToHTML(lab_experiments.getCurrentContent()),
            lab_name,
            semester,
            lab_manual
        }


        PostData(`/${this.props.apikey}/createlaboratory`, d)
        .then((resp) => {
            confirmAlert({
                title: resp,
                buttons: [
                    {
                        label: 'Okay'
                    }
                ]
            });
        })
        
    }
    render() {
        let { classes } = this.props;
        return (
            <div>
                <form onSubmit={this.onSubmit}>
                    <Card>
                        <CardHeader
                            title={`Add Laboratory`}
                            action={
                                <Link to="/laboratory/view">
                                    <Button
                                    color="primary"
                                    
                                >
                                    View All
                                </Button>
                                </Link>
                            }
                        />

                        <CardContent style={{ width: '100%' }}>
                            <Grid container spacing={24}>
                                <Grid item xs={12} sm={12} lg={8} md={8}>
                                    <label>Name of the Laboratory</label>
                                    <input
                                        className="form-control"
                                        name="lab_name"
                                        onChange={this.onChange}
                                        value={this.state.lab_name}
                                        placeholder="Name of the Lab"

                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} lg={4} md={4}>
                                    <label>Semester</label>
                                    <select
                                        className="form-control"
                                        name="semester"
                                        onChange={this.onChange}
                                        value={this.state.semester}
                                        

                                    >
                                        <option value="">Select</option>
                                        {semesters.map((el,index) => 

                                                <option key={index} value={el.value}>{el.label}</option>
                                            
                                            )}
                                        </select>
                                </Grid>

                                <Grid item xs={12} sm={12} lg={12} md={12}>
                                    <label>Description</label>
                                    <Editor
                                        editorState={this.state.description}
                                        toolbarClassName="toolbarClassName"
                                        wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName"
                                        placeholder="Write something here"
                                        onEditorStateChange={this.onEditorStateChange.bind(this,'description')}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} lg={12} md={12}>
                                    <label>Lab Experiments</label>
                                    <Editor
                                        editorState={this.state.lab_experiments}
                                        toolbarClassName="toolbarClassName"
                                        wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName"
                                        placeholder="Write something here"
                                        onEditorStateChange={this.onEditorStateChange.bind(this, 'lab_experiments')}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} lg={12} md={12}>
                                    <label>Upload Lab Manual</label>
                                    <FileUpload
                                        dp={this.state.lab_manual}
                                        apikey={this.props.apikey}
                                        type={`LAB_MAN`}
                                        setDp={this.onEditorStateChange.bind(this, 'lab_manual')}
                                    />

                                </Grid>
                            </Grid>
                        </CardContent>

                        <CardActions>
                            <Button
                                type="submit"
                                color="primary"
                            >
                                Submit
                            </Button>
                        </CardActions>
                    </Card>
                </form>
            </div>
        );
    }
}

export default withStyles(styles)(LaboratoryLanding);


// WEBPACK FOOTER //
// ./src/Components/Laboratory/LaboratoryLanding.js